import React from 'react';
import './UpdateNotification.css';

function UpdateNotification({ onUpdate, onDismiss }) {
  return (
    <div className="update-notification">
      <div className="update-content">
        <div className="update-icon">🔄</div>
        <div className="update-message">
          <strong>새 버전이 있습니다</strong>
          <p>더 나은 경험을 위해 업데이트를 권장합니다.</p>
        </div>
        <div className="update-actions">
          <button className="update-button update-btn-primary" onClick={onUpdate}>
            새로고침
          </button>
          <button className="update-button update-btn-secondary" onClick={onDismiss}>
            나중에
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateNotification;
